export function readOptionalString(record: Record<string, unknown> | undefined, key: string): string | undefined {
  const value = record?.[key]
  // A blank value renders as a visually missing required field, so treat it as absent.
  return typeof value === 'string' && value.trim() !== '' ? value : undefined
}

export function readOptionalFiniteNumber(record: Record<string, unknown> | undefined, key: string): number | undefined {
  const value = record?.[key]
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined
}

export function readDetailsString(details: Record<string, unknown> | undefined, key: string): string {
  return readOptionalString(details, key) ?? ''
}

export function readDetailsNumber(details: Record<string, unknown> | undefined, key: string): string {
  const value = readOptionalFiniteNumber(details, key)
  return value === undefined ? '' : String(value)
}

export function readDetailsStringList(details: Record<string, unknown> | undefined, key: string): string[] | undefined {
  const value = details?.[key]
  // A non-array, or an array carrying a non-string entry, violates the contract: dropping the
  // offending entry would under-report the fault count, so signal the caller to fall back instead.
  if (!Array.isArray(value) || !value.every((entry): entry is string => typeof entry === 'string')) {
    return undefined
  }
  // Drop blank entries so a mixed list never inflates the bid count or renders an empty start time.
  return value.filter((entry) => entry.trim() !== '')
}

export function readDetailsStringListAllowEmpty(
  details: Record<string, unknown> | undefined,
  key: string
): string[] | undefined {
  const value = details?.[key]
  return Array.isArray(value) && value.every((entry): entry is string => typeof entry === 'string') ? value : undefined
}

export function readDetailsTagListAllowEmpty(
  details: Record<string, unknown> | undefined,
  key: string
): string[] | undefined {
  const value = details?.[key]
  return Array.isArray(value) &&
    value.every((entry): entry is number => typeof entry === 'number' && Number.isFinite(entry))
    ? value.map(String)
    : undefined
}
